import React from 'react';
import { COLORS } from '../../../../config/designSystem/Colors';
import {Stack} from 'expo-router';
import { title } from '../../../../components/Root/title';
import { useHideNavigationMenu } from '../../../../hooks/navigation/useHideNavigationMenu';


export default function Layout(){

  useHideNavigationMenu();

  return (
    <Stack screenOptions={({route}) => {
      return({
        headerShown: false,
        title: title(route.name),
        contentStyle: { backgroundColor: COLORS.surface.primary },
      });}
    }/>
  );
}
